<script lang="ts">
  import type { Snippet } from 'svelte';

  let {
    title,
    hint = '',
    nopad = false,
    children,
    actions,
  }: {
    title: string;
    hint?: string;
    nopad?: boolean;
    children: Snippet;
    actions?: Snippet;
  } = $props();
</script>

<div class="glass-card">
  <div class="glass-card-head">
    <span class="head-title">{title}</span>
    <span class="head-right">
      {#if hint}<span class="glass-muted">{hint}</span>{/if}
      {#if actions}{@render actions()}{/if}
    </span>
  </div>
  <div class="glass-card-body" class:nopad>{@render children()}</div>
</div>

<style>
  .glass-card {
    background: var(--glass-bg-card);
    backdrop-filter: var(--glass-blur);
    -webkit-backdrop-filter: var(--glass-blur);
    border: 1px solid var(--glass-border);
    border-radius: var(--radius-xl);
    overflow: hidden;
    box-shadow: var(--glass-shadow);
    transition: box-shadow 0.3s ease, border-color 0.3s ease, transform 0.3s ease;
  }

  .glass-card:hover {
    box-shadow: var(--glass-shadow-lg);
    border-color: var(--glass-border-strong);
  }

  .glass-card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    padding: 0.75rem 1.1rem;
    border-bottom: 1px solid var(--glass-border);
    background: rgba(255,255,255,0.35);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    font-weight: 700;
    color: var(--text-primary);
    font-size: 0.88rem;
    letter-spacing: -0.01em;
  }

  .head-right {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .glass-card-body { padding: 1.1rem; }
  .glass-card-body.nopad { padding: 0; }
  .glass-muted { color: var(--text-muted); font-weight: 500; font-size: 0.78rem; }
</style>
